import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import {
  FunctionalCard,
  FunctionalCardContent,
} from "@ps-design-system/components/cards/FunctionalCard";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@ps-design-system/components/Popover";
import { Text } from "@ps-design-system/components/Text";

type InstantBookLearnMorePopoverProps = {
  testId: string;
};

/** The "Learn More" popover shared by both the eligible and non-eligible instant-book UIs. */
const InstantBookLearnMorePopover = ({
  testId,
}: InstantBookLearnMorePopoverProps) => (
  <Popover>
    <PopoverTrigger asChild={true}>
      <Button
        variant="text-only"
        className="tw-body-1-underline tw-p-0 tw-h-auto"
        testId={testId}
      >
        <FormattedMessage
          id="hosting.activate_listings.instant_book_category_note"
          defaultMessage="Learn More"
        />
      </Button>
    </PopoverTrigger>
    <PopoverContent className="tw-w-[250px]" align="start">
      <FunctionalCard>
        <FunctionalCardContent className="tw-text-gray-900">
          <Text typeface="body-1-long">
            <FormattedMessage
              id="hosting.activate_listings.instant_book_category_note_text"
              defaultMessage="A space cannot be booked instantly if it is less than 24 hours before the event start time. In some cases, you may request to cancel or modify an Instant Booking without penalty. {learnMoreLink}"
              values={{
                learnMoreLink: (
                  <a
                    href="https://support.peerspace.com/hc/en-us/articles/360017989772-Instant-Book-Guidelines"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tw-underline"
                  >
                    <FormattedMessage
                      id="hosting.activate_listings.learn_more"
                      defaultMessage="Learn more"
                    />
                  </a>
                ),
              }}
            />
          </Text>
        </FunctionalCardContent>
      </FunctionalCard>
    </PopoverContent>
  </Popover>
);

export { InstantBookLearnMorePopover };
